import { AfterViewInit, Component, inject, Input, TemplateRef } from '@angular/core';
import { mobiIcon } from '@mobi/rwc-utils-icons-jslib';
import { DOCUMENT } from '@angular/common';

@Component({
  standalone: false,
  selector: 'webform-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.scss'],
})
export class BoxComponent implements AfterViewInit {
  @Input() icon: mobiIcon = 'document';
  @Input() iconRed: boolean = false;
  @Input() content!: TemplateRef<any>;
  @Input() buttons!: TemplateRef<any>;

  readonly #document = inject(DOCUMENT);

  ngAfterViewInit(): void {
    const links: HTMLCollectionOf<Element> =
      this.#document.getElementsByTagName('webform-link');
    if (links?.length) links[0].classList.add('border-t');
  }
}
